import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { toggleModalWithTimer, updateMessages } from 'apps/auth/actions/appAction';
import { updateExtraByName } from 'apps/auth/actions/extraAction';
import { setNewForm } from 'apps/auth/actions/formAction';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import Form from 'apps/auth/components/form-multi/Form';
import { getField } from 'apps/auth/components/form-multi/utils';
import { AUTH_RECIPIENT_DELETE_ACTION } from 'apps/auth/constants/UrlConstants';
import { capitalizeFirstLetters, resolveArguments } from 'apps/auth/helpers/utils';
import { usePageMessages } from 'apps/auth/hooks/selectors';

const FORM_NAME = 'deleteRecipient';

const DeleteRecipientPopup = (props) => {
    const { removeRecipientPopupText, removeButton, recipientRemovedModalText } = usePageMessages();
    const recipientName = `${props.recipient.extra.to_name} ${props.recipient.extra.to_name_f}`;
    const formattedRecipientName = capitalizeFirstLetters(recipientName);

    useEffect(() => {
        const selectedRecipient = props.recipient;
        const recipientIdField = getField('id', selectedRecipient.id);

        props.setNewForm(FORM_NAME, {
            [recipientIdField.name]: recipientIdField,
        });
    }, []);

    const onSubmitHandler = (fields, json) => {
        if (json?.messageBodyMessages) {
            updateMessages(json.messageBodyMessages);
        }
        if (json?.extra) {
            props.toggleModalWithTimer(true, recipientRemovedModalText);
        }
    };

    return (
        <Form action={AUTH_RECIPIENT_DELETE_ACTION} formName={FORM_NAME} validateForm={false} onSubmitHandler={onSubmitHandler}>
            <SimplePopup text={resolveArguments(removeRecipientPopupText, formattedRecipientName)} popupRef={props.popupRef}>
                <PopupButton
                    iconName="cross"
                    text={removeButton}
                    onClick={() => {
                        props.popupRef.current?.close();
                    }}
                    isAlertButton
                    type="submit"
                />
            </SimplePopup>
        </Form>
    );
};

DeleteRecipientPopup.propsType = {
    popupRef: PropTypes.shape({ current: PropTypes.object }),
    recipient: PropTypes.object,
};

export default connect(null, {
    setNewForm,
    toggleModalWithTimer,
    updateExtraByName,
})(DeleteRecipientPopup);
